import {
  LOAD_CLIENT_DATA,
  SET_LAST_NAME_FILTER,
  SET_EDIT_CLIENT,
  SET_EDIT_MODE,
  SET_REPORT_CLIENT,
  SET_SORT,
} from '../actions/advisor';

// default clientData state
export const initAdvisorData = {
  'clients': [],
  'lastNameFilter': '',
  'editClient': null,
  'reportClient': null,
  'sortColumn': 'clientName',
  'sortDirection': 'ASC',
  'editMode': '',
};

// advisorData reducer
const advisorData = (state, action) => {
  if(state === undefined) {
    return {};
  }
  switch (action.type) {
    case LOAD_CLIENT_DATA:
      return Object.assign({}, state, {
        clients: action.payload,
      });
    case SET_LAST_NAME_FILTER:
      return Object.assign({}, state, {
        lastNameFilter: action.payload,
      });
    case SET_EDIT_CLIENT:
      return Object.assign({}, state, {
        editClient: action.payload,
      });
    case SET_EDIT_MODE:
      return Object.assign({}, state, {
        editMode: action.payload,
      });
    case SET_REPORT_CLIENT:
      return Object.assign({}, state, {
        reportClient: action.payload,
      });
    case SET_SORT:
      const column = action.column;
      let direction = 'ASC';
      if (column === state.sortColumn) {
        direction = state.sortDirection === 'ASC' ? 'DESC' : 'ASC';
      }
      return Object.assign({}, state, {
        sortColumn: column,
        sortDirection: direction,
      });
    default:
      return state;
  }
};


export const getClients = (state) => state.advisorData.clients;
export const getEditClient = (state) => state.advisorData.editClient;
export const getSortColumn = (state) => state.advisorData.sortColumn;
export const getSortDirection = (state) => state.advisorData.sortDirection;


export default advisorData;



// WEBPACK FOOTER //
// ./src/reducers/advisor.js